import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { Button } from '@kyruus/button';

export const ProvidersContainer = styled.div``;

export const SortButtons = styled.div`
  max-width: fit-content;
`;

export const SortButton = styled(Button)`
  color: ${(props) =>
    props.disabled
      ? fromTheme('color_text_disabled')
      : fromTheme('color_link')};
  padding: 0 ${fromTheme('spacing_xsmall')};

  &:not(:first-of-type) {
    border-left: 1px solid ${fromTheme('color_border')};
  }

  &:disabled {
    font-weight: ${fromTheme('font_weight_bolder')};
  }

  &:hover,
  &:focus {
    background-color: unset;
    text-decoration: ${(props) => (props.disabled ? 'none' : 'underline')};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;
